import React from 'react';
import '../CountrySelect.css';
import { useLanguage } from '../context/LanguageContext';
import { COUNTRIES, findCountry, localizedCountryName } from '../utils/countries';

const CountrySelect = ({ value, onChange, language = 'en', placeholder, disabled = false, countryCounts = {}, onlyCountries = null }) => {
  const { t } = useLanguage();
  const selectedCountry = findCountry(value);

  const visibleCountries = onlyCountries
    ? COUNTRIES.filter(c => onlyCountries.includes(c.code))
    : COUNTRIES;

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <select
      className="country-select-simple"
      value={selectedCountry?.code || ''}
      onChange={handleChange}
      disabled={disabled}
    >
      <option value="">
        {placeholder || t('common.selectCountry')}
      </option>
      {visibleCountries.map((country) => {
        const countryName = localizedCountryName(country, language);
        const count = countryCounts[country.code];
        return (
          <option key={country.code} value={country.code}>
            {country.flag} {countryName}{count ? ` (${count})` : ''}
          </option>
        );
      })}
    </select>
  );
};

export default CountrySelect;